import * as actions from 'redux/actions/tour.actions'

const initialState = {
  isOpen: false,
  steps: []
}

const tourReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.openTour.type:
      return {
        ...state,
        isOpen: true
      }
    case actions.closeTour.type:
      return {
        ...state,
        isOpen: false
      }
    case actions.setTourSteps.type:
      return {
        ...state,
        steps: payload.steps
      }
    case 'ROUTE_CHANGE':
    case actions.resetTour.type:
      return initialState
    default:
      return state
  }
}
export default tourReducer
